module.exports = __webpack_public_path__ + "static/img/grand_prix.3d20dcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/grand_prix.jpg
// module id = 29
// module chunks = 0